import { inject, Injectable } from "@angular/core";
import { UpdateService } from "src/app/services/update.service";
import { isE2ETests } from "src/app/support/e2e-tests";

@Injectable()
export class ShowUpdateToastGuard {
  private readonly updateService = inject(UpdateService);

  canActivate(): boolean {
    if (isE2ETests()) {
      return true;
    }

    this.updateService.checkIfLoadedNewVersion();

    return true;
  }
}
